import { useEffect } from "react";
import "./app.css";
import "./common.css";
import "./common2.css";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import AppRoutes from "./routes/AppRoutes";
import Toast from "./componants/toast/Toast";
import { startErrorAutoScroll } from "./utils/scrollToError";

function App() {
  // Scroll to the first validation error after a failed submit.
  useEffect(() => startErrorAutoScroll(), []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <AppRoutes />
          <Toast />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}

export default App;
